<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 2.goodsTitle-container-start -->
    <!-- <goods-title></goods-title> -->
    <tabbar :tabbarIndex="0"></tabbar>
    <!-- <img width="100%" src="../../images/head.png"> -->
    <img
      width="100%"
      :src="web_top_imgurl"
      @click="link(web_top_linkurl)"
      alt=""
    />
    <marquee behavior="scroll" class="tishi">{{ web_rolling_notice }}</marquee>
<div class="person">
        <div class="kefu"
          @click="clicked_OnlineService()"
          style="cursor: pointer;">
        <img
          style="margin-top: 30px; text-align: center"
          src="../../images/kefu.png"
        />
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          在线客服
        </div>
        <div
          style="
            height: 30px;
            line-height: 30px;
            background-color: rgb(204, 127, 12);
            color: #fff;
            margin-top: 10px;
          "
        >
          售后处理
        </div>
      </div>
    </div>
    <!-- 2.goodsTitle-container-end -->

    <!-- 3.goodsMain-container-start -->
    <div class="goodsMain">
      <div class="card borderShadow">
        <div class="left">
          <img v-if="TCInfo.pc_img" :src="TCInfo.pc_img" class="img" />
          <img v-else src="../../images/task1.png" class="img" />
        </div>
        <div class="middle">
          <div class="top">
            {{ TCInfo.setmeal_name || "暂无名称" }} 套餐编号：{{
              TCInfo.setmeal_code
            }}
          </div>
          <div class="middle tishi">提示：</div>
          <div class="middle oneLine">
            您好，您选择的套餐是-{{
              TCInfo.setmeal_name || "暂无名称"
            }}，以下是该套餐的商品。
          </div>
          <div class="bottom twoLine">
            如有疑问欢迎来电咨询:
            <span v-for="(item, index) of web_tel" :key="index"
              >{{ item }} {{ index + 1 == web_tel.length ? "" : "、" }}</span
            >
          </div>
          <button @click="fanhui" class="fanhui">重新选择</button>
        </div>
        <div class="right borderShadow" v-if="GGList.length > 0">
          <div class="tip">公告</div>
          <div
            class="item hands"
            @click="watchGGDetail(item)"
            v-for="(item, index) of GGList"
            :key="index"
          >
            <span>{{ index + 1 }}.</span>{{ item.notice_title || "暂无标题" }}
          </div>
        </div>
      </div>
      <div class="address borderShadow">
        <div class="top">收货人信息</div>
        <div class="bottom">
          <div class="item">
            <div class="left">收货人姓名</div>
            <input
              type="text"
              v-model="consignee"
              maxlength="10"
              placeholder="请输入收货人姓名"
              class="right"
            />
            <span class="red">*</span>
          </div>
          <div class="item">
            <div class="left">收货人电话</div>
            <input
              type="tel"
              v-model="consigneePhone"
              placeholder="请输入收货人电话"
              class="right"
            />
            <span class="red">*</span>
          </div>
          <div class="item">
            <div class="left">备用电话</div>
            <input
              type="tel"
              v-model="consigneePhone2"
              placeholder="请输入备用电话"
              class="right"
            />
            <span class="red">*</span>
          </div>
          <div class="item">
            <div class="left">选择地址</div>
            <div class="right3">
              <select class="item" v-model="provinceIndex">
                <option
                  :value="index"
                  v-for="(item, index) of country"
                  :key="index">
                  {{ item.name }}
                </option>
              </select>
              <select class="item" v-model="cityIndex">
                <option
                  :value="index"
                  v-for="(item, index) of city"
                  :key="index"
                >
                  {{ item.name }}
                </option>
              </select>
              <select class="item" v-model="areaIndex">
                <option
                  :value="index"
                  v-for="(item, index) of area"
                  :key="index"
                >
                  {{ item }}
                </option>
              </select>
              <span class="red" style="margin-left: -11px;">*</span>
            </div>
          </div>
          <div class="item">
            <div class="left">详细地址</div>
            <input
              v-model="consigneeAddr"
              type="text"
              placeholder="请输入详细地址"
              maxlength="50"
              class="right"
            />
            <span class="red">*</span>
          </div>
          <div class="item">
            <div class="left"><span class="red"></span>客服工号</div>
            <input
              v-model="workNumber"
              type="text"
              placeholder="请输入工号"
              class="right"
            style="margin-left:-10px"/>
          </div>
          <div class="item">
            <div class="left"><span class="red"></span>备注</div>
            <textarea
              v-model="consigneeRemark"
              placeholder="请输入备注信息"
              class="right right2"
            style="margin-left:-10px"></textarea>
          </div>
          <div
            class="submit flexStyle1 c-animation hands"
            @click="submitBefore"
          >
            提交
          </div>
        </div>
      </div>
      <!--悬浮小广告样式的提示信息-->
      <!-- <div
        id="thediv"
        ref="thediv"
        style="position: absolute; z-index: 111; left: 0; top: 0"
        v-show="thedivShow"
        @mouseover="clearFdAd"
        @mouseout="starFdAd"
        v-if="GGList.length > 0"
      >
        <div class="right borderShadow" v-if="GGList.length > 0">
          <div class="tip">公告</div>
          <div
            :class="index > 1 ? 'item hands' : 'item2 hands'"
            @click="watchGGDetail(item)"
            v-for="(item, index) of GGList"
            :key="index"
          >
            <span>{{ index + 1 }}.</span>{{ item.notice_title || "暂无标题" }}
          </div>
        </div> -->
        <!--
        <div
          style="
            cursor: pointer;
            text-align: right;
            font-size: 12px;
            color: #999999;
          "
          @click="thedivShow = false"
        >
          关闭
        </div>
        -->
      <!-- </div> -->
    </div>
    <!-- 3.goodsMain-container-end -->

    <!-- 4.goodsFooter-container-start -->
    <!-- <goods-footer></goods-footer> -->
    <c-footer></c-footer>
    <!-- 4.goodsFooter-container-end -->

    <success-cover :isShow="isShow" :showContent="showContent"></success-cover>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
// import goodsTitle from "../../components/goodsTitle/goodsTitle";
// import goodsFooter from "../../components/goodsFooter/goodsFooter";
import successCover from "../../components/successCover/successCover";
import {
  TCInterGGListRequest,
  submitExchangeRequest,
  TCDetailRequest,
  // countryRequest
} from "../../public/js/service";
var interval;

export default {
  data() {
    // 1.data
    return {
      web_rolling_notice: "", //滚动公告
      web_top_imgurl: "", // pc顶部图片链接
      web_top_linkurl: "", // pc顶部跳转链接
      currentPageInfo: {}, // 1.1.currentPageInfo
      setmealId: "", // 1.2.套餐id
      token: "", // 1.3.token
      sysId: "", // 1.4.sysId
      cardTypeId: "", // 1.5.卡型id
      TCInfo: {}, // 1.6.套餐信息
      web_tel: "", // 1.7.客服电话
      goodsList: [], // 1.8.套餐下商品列表
      citys_path: "", // 1.9.地址的请求路径
      country: [], // 1.10.全国数据
      provinceIndex: 0, // 1.11.选择的省份位置
      city: [], // 1.12.城市数据
      cityIndex: 0, // 1.13.选择的城市位置
      area: [], // 1.14.区域数据
      areaIndex: 0, // 1.15.选择的城市位置

      consignee: "", // 1.16.收件人姓名
      consigneePhone: "", // 1.17.收件人电话
      consigneeAddr: "", // 1.18.收件人详细地址
      isShow: false, // 1.19.兑换成功遮罩层
      submitTimer: true, // 1.20.提交按钮防止连点

      consigneePhone2: "", // 1.21.备用手机号
      workNumber: "", // 1.22.工号

      GGList: [], // 1.23.套餐公告列表
      showContent: "兑换成功", // 1.24.兑换成功提示语
      consigneeRemark: "", // 1.25.客户备注

      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
    };
  },

  components: {
    // 2.components
    // goodsTitle,
    // goodsFooter,
    tabbar,
    cFooter: footer,
    successCover,
  },

  methods: {
    clicked_OnlineService() {
      var url = localStorage.web_online_service;
      if (url && url != "" && url != "#") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        var tempwindow = window.open("");
        tempwindow.location = url;
      }
    },
    fanhui() {
      this.$router.go(-2);
    },
    // 3.methods
    getTCDetail() {
      // 3.1.获取套餐->获取套餐详情
      let data = {
        cardTypeId: this.cardTypeId,
        setmealId: this.setmealId,
        sysId: this.sysId,
      };
      TCDetailRequest(data).then((res) => {
        if (res) {
          this.TCInfo = res.data[0];
          console.log(this.TCInfo);
          if (this.TCInfo.is_web == 0) {
            this.$notify({
              title: "提示",
              message: this.TCInfo.web_warn,
            });
          }
        }
      });
    },
    getaddress() {
      // 3.4.缓存中读取地址信息
     this.country = JSON.parse(localStorage.country);
    },
    submitBefore() {
      // 3.5.提交之前的验证
      let verifacationResult = this.verifacation();
      if (verifacationResult) { 
        if (this.submitTimer) {
          this.submitRequest();
          
        }
      }
    },

    verifacation() {
      // 3.6.校验表单方法
      if (!this.consignee.trim()) {
        // 收件人姓名校验
        this.$notify({
          title: "提示",
          message: "请输入收件人姓名"
        });
        return;
      }

      if (
        this.consigneePhone.trim().length != 11 ||
        this.consigneePhone.trim().substring(0, 1) != 1
      ) {
        // 收件人电话
        this.$notify({
          title: "提示",
          message: "请输入正确收件人电话",
        });
        return;
      }

      if (!this.consigneePhone2.trim()) {
        // 备用电话
        this.$notify({
          title: "提示",
          message: "请输入备用电话",
        });
        return;
      }

      if (this.provinceIndex == 0) {
        // 省份
        this.$notify({
          title: "提示",
          message: "请选择省份",
        });
        return;
      }

      if (this.cityIndex == 0) {
        // 城市
        this.$notify({
          title: "提示",
          message: "请选择城市",
        });
        return;
      }

      if (this.areaIndex == 0) {
        // 区域
        this.$notify({
          title: "提示",
          message: "请选择区域",
        });
        return;
      }

      if (!this.consigneeAddr.trim()) {
        // 详细地址
        this.$notify({
          title: "提示",
          message: "请输入收件人详细地址",
        });
        return false;
      }

      return true;
    },

    submitRequest() {
      // 3.7.申请请求
      this.submitTimer = false; // 3.7.1.关闭请求开关
      this.openLoading();
      let data = {
        province: this.country[this.provinceIndex].name,
        city: this.city[this.cityIndex].name,
        area: this.area[this.areaIndex],
        consignee: this.consignee,
        consigneeAddr: this.consigneeAddr,
        consigneePhone: this.consigneePhone,
        sysId: this.sysId,
        sonList2: [{ setmealId: this.setmealId }],

        consigneePhone2: this.consigneePhone2,
        workNumber: this.workNumber,
        consigneeRemark: this.consigneeRemark,
      };

      submitExchangeRequest(data).then((res) => {
        console.log("data")
        console.log(data)
        this.submitTimer = true;
        this.closeLoading();
        if (res) {
          console.log(res)
          setTimeout(() => {
            // debugger;
            this.isShow = true;
            this.showContent = res["data"][0]["info"];
            console.log("showContent")
             console.log(this.showContent)
            //this.showContent = "兑换成功1";
            this.$router.push("/succes");
          }, 1000);
        }
      });
    },

    getGGList() {
      // 3.8.套餐->公告列表
      let data = {
        setmealId: this.setmealId,
        sysId: this.sysId,
        pageNo: -1,
        pageSize: -1,
      };

      TCInterGGListRequest(data).then((res) => {
        if (res) {
          this.GGList = res.rows;
        }
      });
    },

    watchGGDetail(item) {
      // 3.9.查看公告详情
      let obj = {
        noticeId: item.notice_id,
        token: this.token,
      };
       
      this.$router.push(
        "/ggDetail?type=1&obj=" + encodeURIComponent(JSON.stringify(obj))
      );
    },

    openLoading() {
      // 3.10.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.11.关闭遮罩层
      this.loadingInstance.close();
    },

    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (null != this.$refs.thediv) {
        this.Hoffset = this.$refs.thediv.offsetHeight; //获取元素高度
        this.Woffset = this.$refs.thediv.offsetWidth;
      }

      this.xPos = width - this.Woffset;
      this.yPos = height / 2 - this.Hoffset / 2;

      if (null != this.$refs.thediv) {
        // 滚动部分跟随屏幕滚动
        this.$refs.thediv.style.left =
          this.xPos +
          document.body.scrollLeft +
          document.documentElement.scrollLeft +
          "px";
        this.$refs.thediv.style.top =
          this.yPos +
          document.body.scrollTop +
          document.documentElement.scrollTop +
          "px";
      }

      // 滚动部分不随屏幕滚动
      //   this.$refs.thediv.style.left =
      //     this.xPos + document.body.scrollLeft + "px";
      //   this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

      //   if (this.yon) {
      //     this.yPos = this.yPos + this.step;
      //   } else {
      //     this.yPos = this.yPos - this.step;
      //   }
      //   if (this.yPos < 0) {
      //     this.yon = 1;
      //     this.yPos = 0;
      //   }
      //   if (this.yPos >= height - this.Hoffset) {
      //     this.yon = 0;
      //     this.yPos = height - this.Hoffset;
      //   }

      //   if (this.xon) {
      //     this.xPos = this.xPos + this.step;
      //   } else {
      //     this.xPos = this.xPos - this.step;
      //   }
      //   if (this.xPos < 0) {
      //     this.xon = 1;
      //     this.xPos = 0;
      //   }
      //   if (this.xPos >= width - this.Woffset) {
      //     this.xon = 0;
      //     this.xPos = width - this.Woffset;
      //   }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
    link(url) {
      if (url != "") {
        url =
          url.toLowerCase().indexOf("http:") > -1 ||
          url.toLowerCase().indexOf("https:") > -1
            ? url
            : "http://" + url;
        window.location = url;
      }
    },
  },

  mounted() {
    // 4.mounted
    this.sysId = localStorage.sysId || "";
    // this.citys_path = localStorage.citys_path || "";
    this.web_tel = JSON.parse(localStorage.web_tel) || "";
    this.web_rolling_notice = localStorage.web_rolling_notice || ""; //滚动公告
    this.web_top_imgurl = localStorage.web_top_imgurl || "";
    this.web_top_linkurl = localStorage.web_top_linkurl || "";

    let res = JSON.parse(decodeURIComponent(this.$route.query.obj));
    this.token = res.token;
    this.setmealId = res.setmealId;
    this.cardTypeId = res.cardTypeId;
    this.getTCDetail();
    this.getaddress();
    this.getGGList();
    interval = setInterval(this.changePos, this.delay);
  },

  watch: {
    // 5.watch
    provinceIndex() {
      // 5.1.监听省份的选择变化
      this.city = this.country[this.provinceIndex].cityList;
      this.area = [];
      this.areaIndex = 0;
      this.cityIndex = 0;
    },

    cityIndex() {
      // 5.2.监听城市的选择变化
      this.area = this.city[this.cityIndex].areaList;
      this.areaIndex = 0;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./goodsAddress.scss";
.red{
  margin-right: 0px;
}
</style>